import React from "react";
import { Link } from "react-router-dom";
import { IconButton } from "@outpave/ds";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight02Icon } from "@hugeicons-pro/core-stroke-rounded";

interface PanelArrowLinkProps {
  to: string;
  label: string;
}

// TODO(OUT-1566): move into the DS Card component as its "view all" link action, then delete this.
/** A dashboard panel's "view all" arrow: a DS IconButton that is a real router link. */
const PanelArrowLink: React.FC<PanelArrowLinkProps> = ({ to, label }) => (
  // The DS props do not declare `to`, so it rides in a spread through to `Link`.
  <IconButton
    component={Link}
    {...{ to }}
    variant="outlined"
    aria-label={label}
  >
    <HugeiconsIcon icon={ArrowRight02Icon} size={18} />
  </IconButton>
);

export default PanelArrowLink;
